import {Inject, Component, Input, OnChanges, SimpleChange} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { CareerOneStopAPIService } from '../careerOneStop.service';

@Component({
	selector: 'app-career-one-stop-video-icon',
	templateUrl: './career-one-stop-video.component.html',
	styleUrls: ['./career-one-stop-video.scss'],
	standalone: false
})
export class CareerOneStopVideoIconComponent {
	@Input() onetCode: string = "";
	@Input() preCheck: boolean = false; //when try, not display icon if there is no video
	@Input() tipPos: "left" | "top" | "bottom" | "" = ""; // display tooltip at left/right/top/bottom default is empty (not display)
	@Input() showVideo: boolean = false; // when click outside text

	constructor(
		private careerOneStopAPI: CareerOneStopAPIService,
		private dialog: MatDialog
	) { }

	displayIcon: boolean = false;
	displayPopup: boolean = false;
	loading: boolean = false;
	toolTip: string = ""
	private video: any = null;
	private myPopup: any = null;

	private popupVideo(): void {
		if (this.video == null || this.displayPopup) {
			return;
		}
		this.displayPopup = true;
		this.myPopup = this.dialog.open(
			CareerOneStopVideoDialog,
			{
				width: '800px',
				panelClass: 'jmDialogNoScroll',
				data: {
					video: this.video
				}
			}
		);
		this.myPopup.afterClosed().subscribe(
			() => {
				this.displayPopup = false;
			}
		);
	}

	displayVideo(): void {
		if (this.video != null) {
			this.popupVideo();
		}
		else {
			this.loading = true;
			this.careerOneStopAPI.getOccupationVideo(this.onetCode).subscribe(
				response => {
					this.loading = false;
					this.video = response;
					this.popupVideo();
				},
				error => {
					console.log(error);
					this.loading = false;
					
					if (error.status == 504) {
						Swal.fire("", "Oops!  It seems that we are having problems retrieving the video! Please try again later.", "info");
					} else {
						Swal.fire("", "Emmy nominated films don\'t happen overnight. Check back soon!", "info");
					}
				}
			);
		}
	}

	private initIcon(): void {
		if (this.onetCode === '') {
			this.displayIcon = false;
			return;
		}
		else if (this.preCheck === true && this.video == null) {
			this.displayIcon = false;
			this.loading = true;
			this.careerOneStopAPI.getOccupationVideo(this.onetCode).subscribe(
				(response) => {
					this.loading = false;
					this.video = response;
					this.displayIcon = true;
				},
				(error) => {
					console.log(error);
					this.loading = false;
					this.video = null;
					this.displayIcon = false;
				}
			);
		}
		else {
			this.displayIcon = true;
		}
	}

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		//this watch provides a way to know if user clicked on some text, such as label from parent of this directive.
		if (changes['onetCode']) {
			this.video = null;
			this.toolTip = this.tipPos === "" ? "" : "Video";
			this.onetCode = this.onetCode.trim();
			this.initIcon();
		}
		else if (changes['showVideo']) {
			if (this.showVideo) {
				this.displayVideo();
			}
		}
	}

	ngOnDestroy() {
		if (this.myPopup != null) {
			this.myPopup.close();
		}
	}

	ngOnInit(): void {
	}
}



@Component({
	templateUrl: './career-one-stop-video.dialog.html',
	styleUrls: ['./career-one-stop-video.scss'],
	standalone: false
})
export class CareerOneStopVideoDialog {
	video: any
	videoTitle: string = "";

	constructor(
		private dialogRef: MatDialogRef<CareerOneStopVideoDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.video = data.video;
		this.videoTitle = this.video.VideoTitle;
	}

	closeModal(e:any): void {
		this.dialogRef.close(null);
	}
}
